import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { QuestionAnswerSearchProvider } from './context/question-answer-search-context';
import { QuestionAnswerSearchComponent } from './question-answer-search-component';

export function QuestionAnswerSearchFactory() {
    return (
        <BaseLayoutFactory>
            <QuestionAnswerSearchProvider>
                <QuestionAnswerSearchComponent />
            </QuestionAnswerSearchProvider>
        </BaseLayoutFactory>
    );
}
